import { browserHistory } from 'react-router'
let config = require('config');

export function isMshAdmin() {
  return checkScope('mshadmin');
}

export function isMasterAdmin() {
  return checkScope('novus.admin');
}

export function isSuperAdmin(org = null) {
  if (org && !checkOrg(org)) return false;
  return checkScope('ingle.insurance.superadmin');
}

export function isBaseAdmin() {
  return checkScope('ingle.insurance.admin');
}

export function isAdmin(org = null) {
  if (org && !checkOrg(org)) return false;
  return isBaseAdmin()|| isSuperAdmin() || isMasterAdmin() || isMshAdmin();
}

export function isSchoolAdmin() {
  return ['schooladmin', 'schoolsuperadmin'].includes(sessionStorage.getItem('access_level'));
}

export function isSchoolSuperAdmin() {
  return sessionStorage.getItem('access_level') === 'schoolsuperadmin';
}

export function isGroupAdmin() {
  return sessionStorage.getItem('access_level') === 'groupadmin';
}

export function isAgent(org = null) {
	if(org && !checkOrg(org)) return false;
  return checkScope('ingle.insurance.agent');
}

export function isReadonly(org = null) {
  if(org && !checkOrg(org)) return false;
  return checkScope('ingle.insurance.admin_readonly');
}

export function isViewonly() {
  return sessionStorage.getItem('access_level') === 'viewonly';
}

function checkScope(scope) {
	return sessionStorage.getItem('scopes').split(',').includes(scope)
}

export function getAuthLevel(authLevel = null) {
  return authLevel ? sessionStorage.getItem('auth_level') === authLevel : sessionStorage.getItem('auth_level');
}

export function getAccessLevel() {
  return sessionStorage.getItem('access_level');
}

export function checkAccessLevel(accessLevel) {
  return getAccessLevel() === accessLevel;
}

export function getCsrToken() {
  return sessionStorage.getItem('csr_token');
}

function getSchool() {
  return sessionStorage.getItem('school') || '';
}

export function checkSchool(school) {
  return getSchool() === school;
}

export function getOrg() {
	return sessionStorage.getItem('org');
}

export function checkOrg(org = null) {
	return getOrg() == org;
}

export function getPortal() {
  switch (location.hostname) {
    case 'dashboard.rimiinsurance.com':
    case 'dev-dashboard.rimiinsurance.com':
      return 'rimi';
    case 'dashboard.msg-insurance.com':
    case 'dev-dashboard.msg-insurance.com':
      return 'msg';
    case 'dashboard.2visitcanada-insurance.com':
    case 'dev-dashboard.2visitcanada-insurance.com':
      return 'visitcanada';
    case 'insurecanada.policy-dashboard.com':
    case 'dev-insurecanada.policy-dashboard.com':
      return 'insurecanada';
    default:
      return 'ingle';
  }
}

export function isLoggedIn() {
	return sessionStorage.getItem('auth') != null && sessionStorage.getItem('org') != null
}

export function redirectIfNotLoggedIn() {
	if (!isLoggedIn()) {
      window.location.pathname = '/login'
    }
}

function hasBulkPermission() {
  return sessionStorage.getItem('scopes').includes('bulkupload');
}

export function canViewClaims() {
  return sessionStorage.getItem('scopes').includes('view_claims');
}

export function canBulkUpload() {
  return isAdmin() || isMasterAdmin() || hasBulkPermission();
}

export function signOut() {
  sessionStorage.removeItem('auth');
  sessionStorage.removeItem('csr_token');
  sessionStorage.removeItem('auth_level');
  sessionStorage.removeItem('org');
  sessionStorage.removeItem('config');
  sessionStorage.removeItem('scopes');
  sessionStorage.removeItem('all_schools');

  if(sessionStorage.getItem('microsite')){
    browserHistory.push(`/login/${sessionStorage.getItem('microsite')}`);
    sessionStorage.removeItem('microsite');
    return;
  }

  browserHistory.push('/');
}

export function updateVersion() {
  if (sessionStorage.getItem('version') !== config.default.version)
  {
    isLoggedIn() && sessionStorage.removeItem('config');
    sessionStorage.setItem('version', config.default.version);
    window.location.reload();
  }
}

export function getTrackingCode() {
  return `&tracking_code=${isSchoolAdmin() || isGroupAdmin() ? getSchool() : getCsrToken()}`;
}

export function getUserCode(paymentProvider) {
  return isSchoolAdmin() && (paymentProvider === 'invoice') ? `&user_code=${getCsrToken()}` : '';
}

export function getAffiliateCode(){
  return checkOrg('ingle') && !isAgent() ? `&affiliate_code=${getCsrToken()}` : '';
}

export function setLang(event) {
  const lang = event.target.value
  sessionStorage.setItem('locale', lang)
  setLocale(lang)
  location.reload();
}

export function userPermissions(user, orgs) {
  const userOrg = orgs.map((org) => (getOrg() === org));
  return getAccessLevel() === user && userOrg.some(val => val === true);
}

export function isRimiOrg(org) {
  return ['rimi', 'visitcanada', 'insurecanada'].includes(org);
}


// WEBPACK FOOTER //
// ./src/helpers/access.js